import { useEffect, useState } from 'react';
import { useSwipeable } from 'react-swipeable';

export default function useSlidenav(slidesRef: any, dispatch: any, state: any) {
  const [point, setPoint] = useState([0, 0]);
  const [mMTimer, setMMTimer]: any = useState(null);
  const [mWTimer, setMWTimer]: any = useState(null);

  const goToNextSlide = (currSeq: number) => {
    if (currSeq < state.maxSlide) {
      dispatch({ type: 'switch', load: { nextSlide: currSeq + 1 } });
    }
  };
  const goToPrevSlide = (currSeq: number) => {
    if (currSeq > 1) {
      dispatch({ type: 'switch', load: { nextSlide: currSeq - 1 } });
    } else {
      dispatch({ type: 'backtop' });
    }
  };
  const getCurrentSeq = (slidesRef: any) => {
    return parseInt(slidesRef.current.dataset.seq);
  };

  useEffect(() => {
    const keyupFunc = (e: any) => {
      const keyCode = (window as any).event.keyCode;
      const currSeq = getCurrentSeq(slidesRef);
      if (keyCode === 13 || keyCode === 32 || keyCode === 39 || keyCode === 40) {
        // 右箭头、下箭头
        goToNextSlide(currSeq);
      } else if (keyCode === 37 || keyCode === 38) {
        //左箭头，上箭头
        goToPrevSlide(currSeq);
      }
    };

    const clickFunc = (e: any) => {
      const currSeq = getCurrentSeq(slidesRef);
      goToNextSlide(currSeq);
    };

    window.addEventListener('keyup', keyupFunc);
    window.addEventListener('click', clickFunc);

    return () => {
      window.removeEventListener('keyup', keyupFunc);
      window.removeEventListener('click', clickFunc);
    };
  }, [state.maxSlide, slidesRef]);

  useEffect(() => {

    const mouseWheelFunc = (e: any) => {
      const THRESHOLD_CAN_SLIDE = 10;
      if (mWTimer) clearTimeout(mWTimer);
      const _mWTimer = setTimeout(() => {
        const currSeq = getCurrentSeq(slidesRef);
        if (e.clientY - point[1] > THRESHOLD_CAN_SLIDE) {
          goToNextSlide(currSeq);
        } else if (e.clientY - point[1] < -THRESHOLD_CAN_SLIDE) {
          goToPrevSlide(currSeq);
        } else {
          setPoint([e.clientX, e.clientY]);
        }
      }, 300);
      setMWTimer(_mWTimer);
    };

    const mouseMoveFunc = (e: any) => {
      if (mMTimer) clearTimeout(mMTimer);
      if (mWTimer) clearTimeout(mWTimer);
      const _mMTimer = setTimeout(() => {
        setPoint([e.clientX, e.clientY]);
      }, 30);
      setMMTimer(_mMTimer);
    };

    window.addEventListener('mousewheel', mouseWheelFunc);
    window.addEventListener('mousemove', mouseMoveFunc);
    return () => {
      window.removeEventListener('mousewheel', mouseWheelFunc);
      window.removeEventListener('mousemove', mouseMoveFunc);
    };
  }, [point, slidesRef, state.maxSlide, mMTimer, mWTimer]);

  const handlers = useSwipeable({
    onSwipedUp: () => {
      const currSeq = getCurrentSeq(slidesRef);
      if (currSeq < state.maxSlide) {
        dispatch({ type: 'switch', load: { nextSlide: currSeq + 1 } });
      }
    },
    onSwipedDown: () => {
      const currSeq = getCurrentSeq(slidesRef);
      if (currSeq > 1) {
        dispatch({ type: 'switch', load: { nextSlide: currSeq - 1 } });
      } else {
        dispatch({ type: 'backtop' });
      }
    },
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  return [state.nextSlide, handlers];
}
